import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ArchiveItem {
  reference: string;
  clientName: string;
  email: string;
  revenue: string;
  matricule: string;
  phoneNumbers?: string[];
  addresses?: { addressType: string; pays: string; region: string; codePostal: string; adresse: string }[];
  type?: string;
  authorizedOverdraft?: string;
  priceType?: string;
  paymentPeriod?: string;
  paymentPeriodValue?: number;
  customPrices?: { id: string; name: string; value: number }[];
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private tableData = new BehaviorSubject<ArchiveItem[]>([]);
  tableData$ = this.tableData.asObservable();

  getTableData(): ArchiveItem[] {
    return this.tableData.getValue();
  }

  setTableData(data: ArchiveItem[]): void {
    this.tableData.next(data);
  }
}